import { Pinia, Store, getActivePinia } from "pinia";

interface ExtendedPinia extends Pinia {
  _s: Map<string, Store>;
}
export const $ResetPinia = (): void => {
  const pinia = getActivePinia() as ExtendedPinia;

  if (!pinia) {
    return;
  }

  pinia._s.forEach((store, name) => {
    if (name != 'online') {
      store.$reset()
    }
  });
};